// Control Item Options
export const UPDATE_ITEM_OPTION_REQUEST = "UPDATE_ITEM_OPTION_REQUEST";
export const UPDATE_ITEM_OPTION_SUCCESS = "UPDATE_ITEM_OPTION_SUCCESS";
export const UPDATE_ITEM_OPTION_ERROR = "UPDATE_ITEM_OPTION_ERROR";
export const UPDATE_ITEM_OPTION_FAILURE = "UPDATE_ITEM_OPTION_FAILURE";
export const UPDATE_ITEM_OPTION_CLEAR = "UPDATE_ITEM_OPTION_CLEAR";
